module.exports = __webpack_public_path__ + "static/media/dropdown-menu.57ee0dac.png";